import { Component, Decision } from '../structure';
import getValue from './getValue';
import { ThemeProps, TokenOptions } from './types';

export const getToken = <V extends string>(
    props: ThemeProps,
    componentName: Component,
    tokenName: Decision,
    options?: TokenOptions<V>
) => getValue<V>(props.theme.tokens[componentName], tokenName, options);
